import RedactionSearchResults from './RedactionSearchResultsContainer';
export default RedactionSearchResults;